/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import React from "react";
import TextField, { OutlinedTextFieldProps } from "@mui/material/TextField";
import { Typography, useTheme } from "@mui/material";

interface Props extends Omit<OutlinedTextFieldProps, "onChange" | "variant"> {
  onChange: (str: string | number) => void;
  hasError?: boolean;
  messageError?: string;
}

// Formata o número com separador de milhar
const formatNumber = (value: string | number | unknown) => {
  const number = Number(value?.toString().replace(/\D/g, ""));
  if (isNaN(number)) return "";
  return new Intl.NumberFormat("pt-BR").format(number);
};

// Remove qualquer caractere que não seja número
const unformatNumber = (formatted: string) => {
  return formatted.replace(/\D/g, "");
};

const NumericInput: React.FC<Props> = ({
  label,
  value,
  hasError,
  messageError,
  disabled = false,
  onChange,
  ...props
}) => {
  const theme = useTheme();

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    if (value.length === 0) return onChange(-1);
    const unmasked = unformatNumber(event.target.value);
    onChange(unmasked);
  };

  const getFormattedValue = (value: number | unknown) =>
    value === -1 ? "" : formatNumber(value);

  return (
    <>
      {label && (
        <Typography
          fontFamily={"Open Sans"}
          fontWeight={700}
          color={"shadesOfDark.dark"}
          mb={0.5}
        >
          {label}
        </Typography>
      )}
      <TextField
        fullWidth
        value={getFormattedValue(value)}
        onChange={handleInputChange}
        inputProps={{
          inputMode: "numeric",
        }}
        sx={{
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none",
          },
          "& div > input": {
            padding: 1,
            cursor: "pointer",
            border: "1px solid",
            borderRadius: 1,
            borderColor: theme.palette.shadesOfDark.light,
          },
          "& input.Mui-disabled": {
            backgroundColor: "shadesOfDark.ultraLight",
            WebkitTextFillColor: "inherit",
            color: "shadesOfDark.black",
            cursor: "not-allowed",
            opacity: 0.9,
          },
        }}
        disabled={disabled}
        {...props}
      />
      {hasError && (
        <Typography
          mt={0.5}
          fontFamily={"Open Sans"}
          fontSize={10}
          color={"systemColors.error.main"}
        >
          {messageError}
        </Typography>
      )}
    </>
  );
};

export default NumericInput;
